import {DispatchRequestEntity} from "@ots-frontend/ots-data";
import {Grid} from "@mantine/core";
import {
  DispatchDispatchRequestAssocDataTable
} from "../../data-table/DispatchDispatchRequestAssocDataTable/DispatchDispatchRequestAssocDataTable";

export type DispatchRequestJobsProps = {
  dispatchRequest: DispatchRequestEntity;
  showViewAction?: boolean;
}

export const DispatchRequestJobs = (props: DispatchRequestJobsProps) => {
  const {dispatchRequest, showViewAction = true} = props;

  return (
    <Grid>
      <Grid.Col span={12}>
        <DispatchDispatchRequestAssocDataTable
          withBorder={true}
          showViewAction={showViewAction}
          records={dispatchRequest.dispatches}/>
      </Grid.Col>
    </Grid>
  );
};
